module.exports = __webpack_public_path__ + "img/icon-pause-circle.71defe21.svg";